import styled from 'styled-components';

export const ControlsFlexWrapper = styled.div`
	margin-top: 22px;
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
`;

